








































import { Component, Vue } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import DialogDetail from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box1/dialogDetail.vue';

@Component({
  components: { DialogDetail },
})
export default class Dialog1 extends Vue {
  private dialogVisible = false;
  private level: any = [];
  private finishOptions: any = [
    { label: '重大风险', value: 'D' },
    { label: '较大风险', value: 'C' },
    { label: '一般风险', value: 'B' },
    { label: '低风险', value: 'A' },
  ];
  private levelClass(level: any) {
    return {
      'num-text--b': level === '低风险',
      'num-text--y': level === '一般风险',
      'num-text--o': level === '较大风险',
      'num-text--r': level === '重大风险',
    };
  }

  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total: any = 0;
  private tableData: any = [];

  private filterForm: any = {
    areaId: '',
    level: [],
  };

  private showDialog(areaId: any) {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.filterForm.level = ['A', 'B', 'C', 'D'];
    this.filterForm.areaId = areaId || '';
    this.getData();
    this.dialogVisible = true;
  }
  private getData() {
    zyScreenServer
      .getBYRiskLevelData({
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        level: this.filterForm.level,
        areaId: this.filterForm.areaId,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.warning(res.msg);
        }
      });
  }
  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getData();
  }
  private changeSelect(data: any) {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    console.log(data, 'data');
    this.filterForm.level = data;
    this.getData();
  }
  showDetail(item: any) {
    const refName = 'DialogDetailRef';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(item);
  }

  handleClose(done: any) {
    done();
  }
}
